import { twMerge } from "tailwind-merge";

import { useThemePreviewContext } from "containers/admin/clients/client/theme-page/contexts/theme-preview-context";

interface PreviewAreaHeaderProps {
  isMobileView: boolean;
}

const PreviewAreaHeader = ({ isMobileView }: PreviewAreaHeaderProps) => {
  const { senderDetails } = useThemePreviewContext();

  // Helper function to handle empty strings and return fallback value
  const getValueOrFallback = (
    value: string | undefined,
    fallback: string = "Not defined",
  ): string => {
    return value && value.trim() ? value : fallback;
  };

  // Use sender details if available, otherwise fall back to client name
  const displayName = getValueOrFallback(senderDetails?.senderName);
  const displayEmail = getValueOrFallback(senderDetails?.senderEmail);

  return (
    <div className="flex text-sm text-gray-600 px-4 py-3">
      {displayName && (
        <span className="inline-flex bg-gray-800 size-10 aspect-square capitalize font-medium items-center justify-center rounded-full text-white">
          {displayName[0]}
        </span>
      )}
      <div className="flex flex-col gap-1 pl-3">
        <div
          className={
            isMobileView ? "flex flex-col break-words whitespace-normal" : "flex flex-row truncate"
          }
          style={isMobileView ? { wordBreak: "break-word", overflowWrap: "break-word" } : {}}>
          <h3 className="font-bold">{displayName}</h3>
          <p className={twMerge(!isMobileView && "pl-1")}>{`<${displayEmail}>`}</p>
        </div>
        <p className="font-medium">
          Securing Your Teen's Bright Future: College Planning Tips Inside
        </p>
        <p className="text-xs text-gray-500">Empower your parenting journey</p>
      </div>
    </div>
  );
};

export default PreviewAreaHeader;
